/* eslint-disable */
import { useContext, useState } from 'react';
import { Paper, Table, TableBody, TableCell, TableContainer, TableHead, TableRow } from '@material-ui/core';
import P, { shape } from 'prop-types';
import ConfirmationDialog from '../ConfirmationDialog';
import { MainContext } from '../../context/ApiContext';
import UserForm from '../UserForm';
import { MaskedTextField } from '../FormFields';
import { Duration, DateTime } from "luxon";


const SummaryReport = ({ listItem, title }) => {
  const [open, setOpen] = useState(false);
  const [openConfirm, setOpenConfirm] = useState(false);
  const [user, setUser] = useState(null);
  const [id, setId] = useState('');
  const [totals, setTotals] = useState({
    inviter_all_leads: 0,
    captures_on_time: 0,
    attendances_on_time: 0,
    had_contact: 0,
    quoted: 0,
    backup_car: 0,
    pague_menos: 0,
    sold: 0,
    conversion: 0,


  });
  const [dialog, setDialog] = useState({
    msg: '',
    title: '',
  });

  const renovation_on_time = listItem.reduce(function(sum, current) {
    return parseInt(sum) + parseInt(current.renovation_on_time);
  }, 0);

  const sold_end_of_validity = listItem.reduce(function(sum, current) {
    return parseInt(sum) + parseInt(current.sold_end_of_validity);
  }, 0);

  const sold_self_indication = listItem.reduce(function(sum, current) {
    return parseInt(sum) + parseInt(current.sold_self_indication);
  }, 0);

  const self_indication_on_time = listItem.reduce(function(sum, current) {
    return parseInt(sum) + parseInt(current.self_indication_on_time);
  }, 0);
  return (
    <>
      <ConfirmationDialog
        open={openConfirm}
        setOpen={setOpenConfirm}
        msg={dialog.msg.length > 0 ? dialog.msg : 'Dialog'}
        title={dialog.title.length > 0 ? dialog.title : 'Dialog'}
      />
      <UserForm open={open} setOpen={setOpen} title={title} user={user} />
      <TableContainer component={Paper}>
        <Table aria-label="simple table">
          <TableHead>
            <TableRow>
              <TableCell>Corretor</TableCell>
              <TableCell>Renovações no Período</TableCell>
              <TableCell>Renovações capturadas no prazo</TableCell>
              <TableCell>Renovações capturadas fora do prazo</TableCell>
              <TableCell>Renovações não capturadas</TableCell>
              <TableCell>Renovados</TableCell>
              <TableCell>% de renovação</TableCell>
              <TableCell>Indicações externas (auto indicação) no período</TableCell>
              <TableCell>Externos (auto indicação) vendidos</TableCell>
              <TableCell>% geral</TableCell>
              <TableCell>Quantidade BKC oferecido</TableCell>
              <TableCell>Quantidade BKC vendido</TableCell>

            </TableRow>
          </TableHead>
          <TableBody>
            {listItem !== null &&
              listItem.map((item) => (
                <TableRow key={item.broker?.id}>
                  <TableCell>{item.broker?.name  || '-'}</TableCell>
                  <TableCell>{item.renovation_on_time}</TableCell> 
                  <TableCell>{item.captures_renovation_on_time || '-'}</TableCell>
                  <TableCell>{item.captures_renovation_not_time || '-'}</TableCell>
                  <TableCell>{item.not_captures_renovation || '-'}</TableCell>
                  <TableCell>{item.sold_end_of_validity || '-'}</TableCell>
                  <TableCell>{Number(item.conversion_renovation).toFixed(2)}%</TableCell>
                  <TableCell>{item.self_indication_on_time || '-'}</TableCell>
                  <TableCell>{item.sold_self_indication || '-'}</TableCell>
                  <TableCell>{Number(item.conversion_self_indication).toFixed(2)}%</TableCell>                   
                  <TableCell>{item.backups_car}</TableCell>
                  <TableCell>{item.backups_car_vend}</TableCell>
                </TableRow>
              ))}
                 <TableRow >
                   
                  <TableCell 
                    style={{fontWeight: 'bold'}}>Total
                  </TableCell>
                  <TableCell style={{fontWeight: 'bold'}}
                    >{listItem.reduce(function(sum, current) {
                      return parseInt(sum) + parseInt(current.renovation_on_time);
                    }, 0)}
                  </TableCell>
                  <TableCell style={{fontWeight: 'bold'}}>
                    {listItem.reduce(function(sum, current) {
                      return parseInt(sum) + parseInt(current.captures_renovation_on_time);
                    }, 0)}
                  </TableCell>
                  <TableCell style={{fontWeight: 'bold'}}>
                    {listItem.reduce(function(sum, current) {
                      return parseInt(sum) + parseInt(current.captures_renovation_not_time);
                    }, 0)}
                  </TableCell>
                  <TableCell style={{fontWeight: 'bold'}}>
                    {listItem.reduce(function(sum, current) {
                      return parseInt(sum) + parseInt(current.not_captures_renovation);
                    }, 0)}
                  </TableCell>
                  <TableCell style={{fontWeight: 'bold'}}>
                    {listItem.reduce(function(sum, current) {
                      return parseInt(sum) + parseInt(current.sold_end_of_validity);
                    }, 0)}
                  </TableCell>

                  <TableCell style={{fontWeight: 'bold'}}
                    >
                      {renovation_on_time == 0 ? ('0.00%') : (((sold_end_of_validity / renovation_on_time)*100).toFixed(2) + '%')}
                  </TableCell>
                  
                  <TableCell style={{fontWeight: 'bold'}}>
                    {listItem.reduce(function(sum, current) {
                      return parseInt(sum) + parseInt(current.self_indication_on_time);
                    }, 0)}
                  </TableCell>

                  <TableCell style={{fontWeight: 'bold'}}>
                    {listItem.reduce(function(sum, current) {
                      return parseInt(sum) + parseInt(current.sold_self_indication);
                    }, 0)}
                  </TableCell>

                  <TableCell style={{fontWeight: 'bold'}}
                    >
                      {(renovation_on_time + self_indication_on_time) == 0 ? ('0.00%') : ((((sold_self_indication + sold_end_of_validity) / (renovation_on_time + self_indication_on_time))*100).toFixed(2) + '%')}
                  </TableCell>
                  
                  <TableCell style={{fontWeight: 'bold'}}>
                    {listItem.reduce(function(sum, current) {
                      return parseInt(sum) + parseInt(current.backups_car);
                    }, 0)}
                  </TableCell>
                  <TableCell style={{fontWeight: 'bold'}}>
                    {listItem.reduce(function(sum, current) {
                      return parseInt(sum) + parseInt(current.backups_car_vend);
                    }, 0)}
                  </TableCell>    
                  <TableCell></TableCell>
                  <TableCell></TableCell>
                </TableRow>
          </TableBody>
        </Table>
      </TableContainer>
    </>
  );
};

SummaryReport.propTypes = {
  listItem: P.arrayOf(
    shape({
      id: P.number,
      name: P.string,
    })
  ),
  title: P.string.isRequired,
};

SummaryReport.defaultProps = {
  listItem: null,
};

export default SummaryReport;
